//@ts-check

/**
 * @type {import("./types").splitPathType}
 */
export default function splitPath(path) {
  if (!path || path === '/') {
    return [{
      name: '',
      path: '/',
      index: 0,
      isFirst: true,
      isLast: true
    }];
  }

  var hasRoot = path[0] == '/';
  path = path.replace(/^\/+|\/+$/g, ''); // trim '/'character
  // add the '/' for the first root

  if (hasRoot) path = '/' + path;
  var segments = path.split('/').map(function (s, idx, parts) {
    var crtPath = path.split('/').slice(0, idx + 1).join('/') || '/';
    return {
      name: s,
      path: crtPath,
      index: idx,
      isFirst: idx === 0,
      isLast: idx === parts.length - 1
    };
  });
  return segments;
}